<template>
  <OmtGrid>
    <OmtRow>
      <OmtTypography as="h1-bold" mb="24px"> Informações da autorização</OmtTypography>
    </OmtRow>
    <OmtRow>
      <OmtTypography as="p1" mb="24px"> Beneficiário que realizará o procedimento</OmtTypography>
    </OmtRow>
    <OmtRow>
      <OmtSelect
        placeholder="Selecione o beneficiário"
        @change="e => (selectedBeneficiario = e)"
        :initialValue="selectedBeneficiario"
        mb="24px"
      >
        <option v-for="(vinculo, index) in beneficiaries" :key="index" :value="vinculo.IdBeneficiario">
          {{ vinculo.Nome }}
        </option>
      </OmtSelect>
    </OmtRow>

    <OmtRow>
      <OmtTypography as="p1" mb="24px">Tipo do evento</OmtTypography>
    </OmtRow>
    <OmtRow mb="32px" :desktopStart="1" :desktopEnd="6">
      <OmtButton
        :disabled="!hasMedicCredentials"
        height="40px"
        fontSize="14px"
        :variant="selectedEvento === 'Medicina' ? 'solid' : 'outline'"
        @click="selectedEvento = 'Medicina'"
        >Medicina</OmtButton
      >
    </OmtRow>
    <OmtRow mb="32px" :desktopStart="7" :desktopEnd="12">
      <OmtButton
        :disabled="!hasOdontoCredentials"
        height="40px"
        fontSize="14px"
        :variant="selectedEvento === 'Odontologia' ? 'solid' : 'outline'"
        @click="selectedEvento = 'Odontologia'"
        >Odontologia</OmtButton
      >
    </OmtRow>
    <OmtRow mb="64px">
      <CBox bg="var(--colors-light-primary-light-gray)" p="16px" borderRadius="8px">
        <CFlex mb="16px">
          <OmtIcons name="circle-exclamation" mr="16px" />
          <OmtTypography as="h2-bold"> Evite atrasos na liberação da sua autorização </OmtTypography>
        </CFlex>
        <OmtTypography as="p1" mb="16px">
          Para que sua autorização seja liberada, confira abaixo as <b>informações obrigatórias</b> que devem ser
          enviadas: <br
        /></OmtTypography>

        <OmtTypography as="p1"> <b>Pedido médico/odontológico:</b></OmtTypography>
        <omt-li>Nome completo e legível do paciente</omt-li>
        <omt-li>Diagnóstico descrito ou codificado - CID 10</omt-li>
        <omt-li>Descrição completa do procedimento</omt-li>
        <omt-li>
          Dados do profissional (nome completo, assinatura, número de registro no conselho regional da classe -
          CRM/CRO);
        </omt-li>
        <omt-li>Data da realização;</omt-li>
        <omt-li>Local e Unidade da realização do evento.</omt-li>
      </CBox>
    </OmtRow>
    <OmtRow
      justifyContent="center"
      :position="['fixed', 'relative']"
      :bottom="['66px', 'unset']"
      left="0"
      :p="['16px']"
      w="100%"
      background-color="white"
    >
      <OmtButton
        pt="16px"
        pb="16px"
        fontSize="14px"
        :w="['100%', '50% !important']"
        @click="submit()"
        mx="auto"
        :disabled="canSubmit"
      >
        Continuar
      </OmtButton>
    </OmtRow>
  </OmtGrid>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data: function () {
    return {
      selectedBeneficiario: "",
      selectedEvento: ""
    };
  },
  methods: {
    ...mapMutations("auths", ["SET_NEW_AUTH"]),
    ...mapActions("auths", ["initBeneficiaries"]),
    submit() {
      this.SET_NEW_AUTH({
        ...this.newAuth,
        selectedEvento: this.selectedEvento,
        selectedBeneficiario: this.selectedBeneficiario
      });
      this.$router.push({
        name: "auths.attachments"
      });
    }
  },
  computed: {
    ...mapState("auths", ["newAuth", "beneficiaries"]),
    ...mapState("saude", ["hasMedicCredentials", "hasOdontoCredentials"]),
    canSubmit() {
      return !this.selectedBeneficiario || !this.selectedEvento;
    }
  },
  async mounted() {
    await this.$root.$emit("hide-loading");
    await this.initBeneficiaries();
  }
};
</script>
